"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var Recipient = require('./recipient');

var Email = /*#__PURE__*/function () {
  function Email(opt) {
    _classCallCheck(this, Email);

    this.toRecipients = [];
    this.ccRecipients = [];
    this.bccRecipients = [];
    this.sendDate = null;
    this.templateLabel = null;
    this.templateParams = {};
    this.notificationId = null;
    this.immediate = false;

    if (opt && opt.details) {
      this.fillObject(clone(opt.details));
    }
  }

  _createClass(Email, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;

      if (opt.toRecipients) {
        opt.toRecipients.forEach(function (toRecipient) {
          return _this.toRecipients.push(new Recipient(toRecipient));
        });
      }

      if (opt.ccRecipients) {
        opt.ccRecipients.forEach(function (ccRecipient) {
          return _this.ccRecipients.push(new Recipient(ccRecipient));
        });
      }

      if (opt.bccRecipients) {
        opt.bccRecipients.forEach(function (bccRecipient) {
          return _this.bccRecipients.push(new Recipient(bccRecipient));
        });
      }

      this.sendDate = new Date(opt.sendDate);
      this.templateLabel = opt.templateLabel;
      this.templateParams = opt.templateParams;
      this.notificationId = opt.notificationId || null;
      this.immediate = opt.immediate || false;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Email.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'email.schema.json',
        type: 'object',
        properties: {
          toRecipients: {
            type: 'array',
            items: {
              $ref: 'recipient.schema.json'
            }
          },
          ccRecipients: {
            type: 'array',
            items: {
              $ref: 'recipient.schema.json'
            }
          },
          bccRecipients: {
            type: 'array',
            items: {
              $ref: 'recipient.schema.json'
            }
          },
          sendDate: {
            type: 'object'
          },
          templateLabel: {
            type: 'string'
          },
          templateParams: {
            type: 'object'
          },
          notificationId: {
            type: ['string', 'null']
          },
          immediate: {
            type: 'boolean'
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return Email;
}();

tv4.addSchema(Recipient.schema());
module.exports = Email;